import api from '../../api';
import _ from 'lodash';

export default {
    state: {},
    mutations: {},
    actions: {
        getData({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post('get-votos', filters);
                resolve(response.data);
            });
        },
        getReports({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post(
                    'get-reportbyelection',
                    filters
                );
                resolve(response.data);
            });
        },
        getReportsDivision({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post(
                    'get-winner-per-division',
                    filters
                );
                resolve(response.data);
            });
        },
        getPreviewDivision({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post(
                    'get-preview-per-division',
                    filters
                );
                resolve(response.data);
            });
        },
        getPlanillas({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post('get-planillas', filters);
                console.log('getPlanillas',{response: response.data, filters, })
                resolve(response.data);
            });
        },
        getCenters({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post('centros', filters);
                resolve(response.data);
            });
        },
        getUresByIdElection({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post('ures', filters);
                resolve(response.data);
            });
        },
        getTables({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post('mesas', filters);
                resolve(response.data);
            });
        },
        getVotesCSV({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post('get-votes-csv', filters);
                resolve(response.data);
            });
        },
        getPlanillasCSV({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post('get-planillas-csv', filters);
                resolve(response.data);
            });
        },
        getCandidates({ commit, dispatch }, filters) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post('get-candidates', filters);
                resolve(response.data);
            });
        },
        getVotesEmitted({ commit }, params) {
            return new Promise(async (resolve, reject) => {
                const response = await api.post(`/get-votos-emitted`, params);
                resolve(response.data);
            });
        },
    },
    modules: {},
};
